export function splitPhase1Text(text) {
  return String(text ?? '').split(/\n{2,}/).map((block) => block.trim()).filter(Boolean)
}

export function partitionPhase1Blocks(blocks = []) {
  return {
    artifactBlocks: blocks.filter((block) => block?.type === 'artifact_card'),
    otherBlocks: blocks.filter((block) => block?.type !== 'artifact_card'),
  }
}

function isInternalOutputLine(line, nextLine = '') {
  const text = String(line ?? '').trim()
  const lowered = text.toLowerCase()
  if (!text) return false
  if (/`?\/(app|data|tmp|var|users|home)\//i.test(text)) return true
  if (/\b(query_documents|stage_document|sandbox_run|composio_run)\b/i.test(text)) return true
  if (/\bmcp_[a-z0-9_]+/i.test(text)) return true
  if (/\bdo-chat-[a-z0-9-]+/i.test(text)) return true
  if (/\b(api|model|session|workspace)\s+(error|failed|id)\b/i.test(text)) return true
  if (/\b503\b/.test(text)) return true
  if (/\bused\s+\d+\s+tools?\b/i.test(text)) return true
  // "Saved to" and "download or open" are valid user-facing phrases for
  // downloaded documents. Only hide a standalone label when it introduces an
  // internal filesystem path on the following line.
  if (/^saved\s+to\s*:?$/i.test(text) && /`?\/(app|data|tmp|var|users|home)\//i.test(nextLine)) {
    return true
  }
  if (lowered.startsWith('next step:')) return true
  return false
}

export function cleanPhase1TextForArtifacts(text, hasArtifacts, allowFallback = true) {
  const lines = String(text ?? '').split('\n')
  const cleaned = lines
    .filter((line, index) => !isInternalOutputLine(line, lines[index + 1]))
    .join('\n')
    .trim()
  if (cleaned || hasArtifacts) return cleaned
  if (!allowFallback) return ''
  return 'I could not complete this yet. Please retry, or paste the source content here and I can continue directly.'
}
